import { render } from "./BrowseMenu.vue?vue&type=template&id=04138389"
import script from "./BrowseMenu.vue?vue&type=script&lang=js"
export * from "./BrowseMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__